import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    cluster:
      'bg-blue-dark absolute top-1/2 left-1/2 flex size-12 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border border-white',
    count: 'heading-xs-bold text-white'
  }
});
